module.exports = __webpack_public_path__ + "static/media/h01.d1ff83f2.jpg";